import { NavLink, Outlet, Link, useLocation } from "react-router-dom";
import { Home, Camera, Trophy, Wallet, User } from "lucide-react";
import { useEffect } from "react";

/** Playful/energetic gamified chrome — green accent, dark canvas. */
export default function TrashLayout() {
  useEffect(() => { document.title = "Jixxeo Trash Hunter"; }, []);
  const loc = useLocation();
  const hideNav = loc.pathname === "/trashhunter/landing";
  return (
    <div className="min-h-screen text-white flex flex-col"
         style={{ background: "radial-gradient(120% 80% at 20% 10%, #063d1d 0%, #001509 55%, #000 100%)",
                  fontFamily: "'Cabinet Grotesk','Outfit',ui-sans-serif" }}
         data-testid="trash-layout">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-black/50 border-b border-[#39FF14]/25">
        <div className="max-w-2xl mx-auto px-4 py-3 flex items-center gap-3">
          <Link to="/browse" className="text-xs mono uppercase tracking-widest text-white/50 hover:text-white" data-testid="trash-back">← Apps</Link>
          <div className="flex-1 text-center">
            <div className="font-black text-lg leading-none">Jixxeo <span className="text-[#39FF14]">Trash Hunter</span></div>
            <div className="text-[9px] uppercase tracking-widest text-white/40">Clean the world · Level up</div>
          </div>
          <div className="w-10" />
        </div>
      </header>

      <main className="flex-1 pb-24">
        <div className="max-w-2xl mx-auto px-4 py-4">
          <Outlet />
        </div>
      </main>

      {!hideNav && (
        <nav className="fixed bottom-0 inset-x-0 z-40 backdrop-blur-xl bg-black/70 border-t border-[#39FF14]/25">
          <div className="max-w-2xl mx-auto grid grid-cols-5">
            <Tab to="/trashhunter" icon={<Home className="w-5 h-5" />} label="Home" testId="trash-tab-home" end />
            <Tab to="/trashhunter/scan" icon={<Camera className="w-5 h-5" />} label="Scan" testId="trash-tab-scan" />
            <Tab to="/trashhunter/missions" icon={<Trophy className="w-5 h-5" />} label="Missions" testId="trash-tab-missions" />
            <Tab to="/trashhunter/wallet" icon={<Wallet className="w-5 h-5" />} label="Wallet" testId="trash-tab-wallet" />
            <Tab to="/trashhunter/me" icon={<User className="w-5 h-5" />} label="Me" testId="trash-tab-me" />
          </div>
        </nav>
      )}
    </div>
  );
}

function Tab({ to, icon, label, testId, end }) {
  return (
    <NavLink to={to} end={end} data-testid={testId}
      className={({ isActive }) =>
        "flex flex-col items-center gap-0.5 py-2.5 text-[10px] uppercase tracking-widest transition-colors " +
        (isActive ? "text-[#39FF14]" : "text-white/50 hover:text-white/80")}>
      {icon}<span className="font-bold">{label}</span>
    </NavLink>
  );
}
